import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { EmitSuccessAlert } from "../../../utils/EmitSuccessAlert";
import { EmitError } from "../../../utils/EmitError";
import SubjectHelpAndSupportService from "../../../services/http/services/SubjectHelpAndSupportService";

export default function useNewSubjectHelpAndSupport() {
    const navigate = useNavigate();

    const handleSubmit = useCallback(async (subjectData: FormData) => {
        try {

            const subjectName = subjectData.get('name') as string;

            await SubjectHelpAndSupportService.createSubject(subjectName);

            EmitSuccessAlert('Assunto cadastrado com sucesso!');

            navigate('/configuracoes/assuntos-ajuda-e-suporte');
        } catch (err) {
            EmitError(err, true, 'newSubject_asdpasmdas');
        }
    }, [navigate]);

    return {
        handleSubmit
    }
}
